import styled from 'styled-components'
import { dimensions, spacing } from '~/constants/theme'

export const TitleMatch = styled.span`
  background-color: var(--chakra-colors-mango-highlight);
`

export const SubtitleWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`

export const SharedVMWrapper = styled.span`
  margin-right: ${spacing.spacingSM};
  padding: 0;
`

export const RootWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: ${spacing.spacingXL};
  box-sizing: border-box;
  background: var(--chakra-colors-bg-panel-dim);
`

export const Wrapper = styled.div`
  padding: ${spacing.spacingXL};
  box-sizing: border-box;
  border-radius: ${dimensions.borderRadiusSM};
  background-color: var(--chakra-colors-bg-panel);
`

export const DateWrapper = styled.div`
  width: 100%;
  height: 20px;
  margin-bottom: ${spacing.spacingSM};
  display: flex;
  align-items: center;
  justify-content: space-between;
`
